const TOKEN_KEY = "jwtToken";
const DEFAULT_TIMEOUT_MS = 8000;

let resolveTokenReady;
let tokenReady = new Promise((resolve) => {
  resolveTokenReady = resolve;
});

/**
 * Reads the current JWT token from sessionStorage.
 * @returns {string|null}
 */
export const getToken = () => sessionStorage.getItem(TOKEN_KEY) || null;

/**
 * Stores the JWT token and releases anyone awaiting `waitForToken()`.
 * Called from the CIAM `initCallBack` / `refreshCallBack`.
 * @param {string} token
 */
export const setToken = (token) => {
  if (!token) {
    return;
  }
  sessionStorage.setItem(TOKEN_KEY, token);
  resolveTokenReady(token);
};

/**
 * Clears the token and resets the readiness promise (used on logout).
 */
export const clearToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  tokenReady = new Promise((resolve) => {
    resolveTokenReady = resolve;
  });
};

/**
 * Resolves as soon as a token is available, or with `null` when the
 * timeout elapses so callers never hang forever.
 * @param {number} timeoutMs
 * @returns {Promise<string|null>}
 */
export const waitForToken = (timeoutMs = DEFAULT_TIMEOUT_MS) => {
  const existing = getToken();
  if (existing) {
    return Promise.resolve(existing);
  }

  return Promise.race([
    tokenReady,
    new Promise((resolve) => setTimeout(() => resolve(getToken()), timeoutMs)),
  ]);
};

const authToken = {
  getToken,
  setToken,
  clearToken,
  waitForToken,
};

export default authToken;


